import React, { useEffect, useState } from "react";
import { Button, Tabs } from "antd";
import ModulePricing from "./ModulePricing";
import FuelBrands from "./FuelBrands";
import FuelTypes from "./FuelTypes";
import VehicleTypes from "./VehicleTypes";
import FleetManagerDocumentRequired from "./FleetManagerDocumentRequired";
import FuelVendorDocumentRequired from "./FuelVendorDocumentRequired";
import VehicleDocumentRequired from "./VehicleDocumentRequired";
import DriverDocumentRequired from "./DriverDocumentRequired";
import FuelAuthorization from "./FuelAuthorization";
import WiPayConfig from "./WiPayConfig";
import { useLocation } from "react-router-dom";
import "./style.css";
import usePageAccess from "../../../Utlis/usePageAccess";

const SystemConfiguration = () => {
  const { canEdit } = usePageAccess("system-configuration");
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "Module Pricing & Settlements",
  );

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  const [btnConfigs, setBtnConfigs] = useState([]);

  const tabs = [
    "Module Pricing & Settlements",
    "Fuel Brands",
    "Fuel Types",
    "Vehicle Types",
    "Fleet Manager Document Required",
    "Fuel Vendor Document Required",
    "Vehicle Document Required",
    "Driver Document Required",
    "Fuel Authorization",
    "WiPay Configuration",
  ];

  return (
    <div className="report system-configue">
      <div className="header-wrapper">
        <Tabs
          className="settings-tabs"
          activeKey={activeTab}
          onChange={(key) => {
            setActiveTab(key);
            setBtnConfigs([]);
          }}
          items={tabs.map((tab) => ({ key: tab, label: tab }))}
        />
      </div>

      <div className="reports-controls">
        <div className="section-title">{activeTab}</div>

        <div className="button-group">
          {(canEdit ? btnConfigs : []).map((btn, index) => (
            <Button
              key={index}
              type={btn.type || "primary"}
              icon={btn.icon}
              onClick={btn.onClick}
              className={`custom-action-btn ${btn.className || ""}`}
            >
              {btn.text}
            </Button>
          ))}
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "Module Pricing & Settlements" && (
          <ModulePricing setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Fuel Brands" && (
          <FuelBrands setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Fuel Types" && (
          <FuelTypes setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Vehicle Types" && (
          <VehicleTypes setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Fleet Manager Document Required" && (
          <FleetManagerDocumentRequired setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Fuel Vendor Document Required" && (
          <FuelVendorDocumentRequired setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Vehicle Document Required" && (
          <VehicleDocumentRequired setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Driver Document Required" && (
          <DriverDocumentRequired setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "Fuel Authorization" && (
          <FuelAuthorization setBtnConfigs={setBtnConfigs} />
        )}
        {activeTab === "WiPay Configuration" && (
          <WiPayConfig setBtnConfigs={setBtnConfigs} />
        )}
      </div>
    </div>
  );
};

export default SystemConfiguration;
